import React, { useState, useContext, useEffect } from "react";
import {
  Flex,
  Text,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
} from "@chakra-ui/react";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { useToastError } from "../../../utils/toastError";

const TimerConfigurationModule = ({
  isOpen,
  onClose,
  moduleId,
  machineName,
}) => {
  const [transactionTime, setTransactionTime] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const { authInfo } = useContext(AuthContext);
  const { dataUser } = authInfo;
  const token = authInfo?.dataUser?.token;
  const userKey = dataUser.key;
  const toastError = useToastError();

  useEffect(() => {
    // Só roda a busca se o modal estiver aberto E tivermos um moduleId
    if (!isOpen || !moduleId) {
      return;
    }

    const fetchTimerConfiguration = async () => {
      setIsLoading(true);
      try {
        const route =
          userKey === "ADMIN"
            ? `${process.env.REACT_APP_SERVIDOR}/configuracoes-modulo-adm/${moduleId}`
            : `${process.env.REACT_APP_SERVIDOR}/configuracoes-modulo/${moduleId}`;

        const response = await axios.get(route, {
          headers: {
            "x-access-token": token,
            "content-type": "application/json",
          },
        });

        if (response.data) {
          const timeConfig = response.data.find(
            (config) => config.chave === "bonus_tempo_transicao"
          );
          if (timeConfig) {
            setTransactionTime(parseInt(timeConfig.valor) || 0);
          } else {
            setTransactionTime(0);
          }
        }
      } catch (error) {
        console.log("Error fetching timer configuration:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTimerConfiguration();
  }, [isOpen, moduleId, token, userKey]);

  const handleSaveTime = async () => {
    setIsLoading(true);
    try {
      const configuracoes = [
        {
          bonus_tempo_transicao: transactionTime.toString(),
        },
      ];

      await axios.put(
        dataUser.key === "ADMIN"
          ? `${process.env.REACT_APP_SERVIDOR}/configuracao-modulo-adm/${moduleId}`
          : `${process.env.REACT_APP_SERVIDOR}/configuracao-modulo/${moduleId}`,
        { configuracoes },
        {
          headers: {
            "x-access-token": authInfo?.dataUser?.token,
            "content-type": "application/json",
          },
        }
      );

      toastError.success("Tempo de transação salvo com sucesso");
    } catch (error) {
      toastError.error("Erro ao salvar tempo de transação");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent backgroundColor="#1a202c">
        <ModalCloseButton color="white" />
        <ModalBody style={{ marginTop: "20px" }}>
          <Flex direction="column" mb={4}>
            <Text color="white" fontSize="24px">
              Configuração de Tempo
            </Text>
            {machineName && (
              <Text color="gray.400" fontSize="16px" mb={4}>
                Máquina: {machineName}
              </Text>
            )}
          </Flex>

          <Flex direction="column" mb={4}>
            <Text color="white" fontSize="18px">
              Cronômetro de 1 min, para desligar colocar 0
            </Text>
            <Text color="white" fontSize="18px">
              O cronômetro só é aplicado para dinheiro em espécie 
            </Text>
            <input
              type="number"
              value={transactionTime}
              onChange={(e) =>
                setTransactionTime(
                  Math.min(Math.max(0, parseInt(e.target.value) || 0), 99)
                )
              }
              min={0}
              max={99}
              style={{
                backgroundColor: "transparent",
                border: "none",
                borderBottom: "1px solid white",
                color: "white",
                fontSize: "22px",
                fontWeight: "700",
                width: "100px",
                outline: "none",
              }}
            />
          </Flex>

          <Flex justifyContent="flex-end">
            <Button
              colorScheme="green"
              isLoading={isLoading}
              loadingText="Salvando..."
              onClick={handleSaveTime}
              mr={3}
            >
              Salvar Tempo
            </Button>
          </Flex>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" onClick={onClose} color="white">
            Fechar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default TimerConfigurationModule;